import { Chip, Grid, Typography, Stack, Link, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";

import { Button } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useProtocol } from "../../hooks/useProtocol";
import { useParams } from "react-router-dom";
import DeleteProtocolDialog from "./Protocol/DeleteProtocolDialog";
import UploadProtocolDialog from "./Protocol/UploadProtocolDialog";
import { useSnackbar } from "../../hooks/useSnackbar";
import Cookies from "js-cookie";
import { baseURL } from "../../api";
import { DataGridComponent } from "../common/DataGridComponent";
import { GridColDef, GridActionsCellItem } from "@mui/x-data-grid-pro";
import DeleteIcon from "@mui/icons-material/Delete";
import AssessmentDetails from "./AssessmentDetails";

const AssessmentPlans: React.FunctionComponent<any> = () => {
  const [openUploadProtocol, setOpenUploadProtocol] = useState(false);
  const { getAllProtocols, allProtocolsData } = useProtocol();
  const [protocolList, setProtocolList] = useState([]);
  const params = useParams();
  const [openDeleteProtocol, setOpenDeleteProtocol] = useState(false);
  const [selectedProtocol, setSelectedProtocol] = useState<any>({});
  const [copyProtocol, setCopyProtocol] = useState({});
  const [file, setFile] = useState<File | null>(null);
  const [isEditProtocol, setIsEditProtocol] = useState(false);
  const [deleteDoc, setDeleteDoc] = useState({});
  const [isUploaded, setIsUploaded] = useState(false);
  const { showSuccess, handleError } = useSnackbar();

  const handleClick = async (data: any) => {
    showSuccess(
      `${data?.protocol_name} download started`,
      "protocol-dowload-start"
    );
    if (data) {
      try {
        const headers = {
          "Content-Type": "application/octet-stream ",
          authorization: `Bearer ${Cookies.get("accessToken")}`,
        };
        const response = await fetch(
          `${baseURL}/protocol/download/${data?.id}`,
          {
            method: "GET",
            headers,
          }
        );
        const responseBlob = await response.blob();
        const blob = new Blob([responseBlob], {
          type: data?.file_type,
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        document.body.appendChild(a);
        a.download = `${params.study_id}_${data.protocol_name}.${data.filename
          .split(".")
          .pop()}`;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
        showSuccess(
          `${data?.protocol_name} downloaded successfully`,
          "protocol-dowload-success"
        );
      } catch (error) {
        handleError(error);
      }
    }
  };
  const handleEdit = (
    e: React.MouseEvent<SVGSVGElement, MouseEvent>,
    data: any
  ) => {
    e.stopPropagation();
    setSelectedProtocol(data);
    setCopyProtocol(data);
    setIsUploaded(true);
    setIsEditProtocol(true);
    setOpenUploadProtocol(true);
  };

  const handleDelete = (
    e: React.MouseEvent<SVGSVGElement, MouseEvent>,
    data: any
  ) => {
    e.stopPropagation();
    setDeleteDoc(data);
    setOpenDeleteProtocol(true);
  };

  const handleClickOpenUploadProtocol = () => {
    setOpenUploadProtocol(true);
  };

  const getAllProtocolFunc = () => {
    getAllProtocols({ study_id: params?.study_id });
  };
  useEffect(() => {
    getAllProtocolFunc();
  }, []);

  useEffect(() => {
    if (allProtocolsData) {
      setProtocolList(allProtocolsData);
    }
  }, [allProtocolsData]);

  const [detailsPage, setDetailsPage] = useState(false);

  const columns: GridColDef[] = [
    {
      field: "procedureName",
      headerName: "Procedure/Test Name",
      minWidth: 220,
      flex: 1,
      renderCell: (params: any) => (
        <>
          <Link onClick={() => setDetailsPage(true)}>
            {params.row.procedureName}
          </Link>
        </>
      ),
    },
    {
      field: "sampleToCollect",
      headerName: "Sample to Collect",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "collector",
      headerName: "Collector",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "actions",
      width: 80,
      align: "center",
      type: "actions",
      headerName: "Action",
      sortable: false,
      getActions: (params) => [
        <GridActionsCellItem
          key={params.row.id}
          icon={<EditIcon />}
          label="Edit"
          showInMenu
        />,
        <GridActionsCellItem
          key={params.row.id}
          icon={<DeleteIcon />}
          label="Delete"
          showInMenu
        />,
      ],
    },
  ];
  const columnsAnalysis: GridColDef[] = [
    {
      field: "procedureName2",
      headerName: "Procedure/Test Name",
      minWidth: 220,
      flex: 1,
      renderCell: (params: any) => (
        <>
          <Link>{params.row.procedureName2}</Link>
        </>
      ),
    },
    {
      field: "sampleType",
      headerName: "Sample Type",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "tester",
      headerName: "Tester",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "actions",
      width: 80,
      align: "center",
      type: "actions",
      headerName: "Action",
      sortable: false,
      getActions: (params) => [
        <GridActionsCellItem
          key={params.row.id}
          icon={<EditIcon />}
          label="Edit"
          showInMenu
        />,
        <GridActionsCellItem
          key={params.row.id}
          icon={<DeleteIcon />}
          label="Delete"
          showInMenu
        />,
      ],
    },
  ];

  return (
    <>
      {detailsPage ? (
        <AssessmentDetails setDetailsPage={setDetailsPage} />
      ) : (
        <>
          <Grid container spacing={2} mb={2}>
            <Grid item xs>
              <Typography variant="h5">Protocol</Typography>
            </Grid>
            <Grid item justifyContent="flex-end">
              <Button
                variant="outlined"
                startIcon={<UploadFileIcon />}
                onClick={handleClickOpenUploadProtocol}
                color="primary"
                aria-label="Click to upload Protocol document and name"
              >
                Upload IND Protocol
              </Button>
              {openUploadProtocol && (
                <UploadProtocolDialog
                  openUploadProtocol={openUploadProtocol}
                  setOpenUploadProtocol={setOpenUploadProtocol}
                  getAllProtocolFunc={getAllProtocolFunc}
                  file={file}
                  setFile={setFile}
                  isEditProtocol={isEditProtocol}
                  setIsEditProtocol={setIsEditProtocol}
                  selectedProtocol={selectedProtocol}
                  setSelectedProtocol={setSelectedProtocol}
                  copyProtocol={copyProtocol}
                  isUploaded={isUploaded}
                  setIsUploaded={setIsUploaded}
                />
              )}
            </Grid>
            <Grid item md={12}>
              <Stack
                direction="row"
                rowGap={1}
                columnGap={1}
                my={1}
                className="flexWrap"
              >
                {protocolList?.map((protocol: any) => {
                  return (
                    <>
                      <Chip
                        label={
                          <Link
                            id={protocol?.id}
                            underline="hover"
                            onClick={() => handleClick(protocol)}
                            aria-label="Click to download Protocol document"
                          >
                            {protocol?.protocol_name}
                          </Link>
                        }
                        variant="outlined"
                        color="primary"
                        onDelete={(e) => handleDelete(e, protocol)}
                        icon={
                          <EditIcon
                            fontSize="small"
                            className="chipCustomIcon"
                            onClick={(e) => handleEdit(e, protocol)}
                            titleAccess="Edit this Protocol"
                          />
                        }
                        className="chipExtraIcon"
                        id={protocol?.id}
                        key={protocol?.id}
                        aria-label="Protol chip with edit and delete icon"
                      />
                    </>
                  );
                })}
              </Stack>
            </Grid>
          </Grid>

          <Typography variant="h5" gutterBottom>
            Sample Collection
          </Typography>
          <Box sx={{ width: "100%", height: "100%", marginBottom: 2 }}>
            <DataGridComponent
              columns={columns}
              rows={[
                {
                  id: "1",
                  procedureName: "Mutation status for study eligibility",
                  sampleToCollect: "Slide",
                  collector: "Site",
                },
                {
                  id: "2",
                  procedureName: "Exploratory Analysis",
                  sampleToCollect: "Unstained Slide",
                  collector: "Site",
                },
              ]}
              showQuickFilter
            />
          </Box>

          <Typography variant="h5" gutterBottom>
            Analysis
          </Typography>
          <Box sx={{ width: "100%", height: "100%", marginBottom: 2 }}>
            <DataGridComponent
              columns={columnsAnalysis}
              rows={[
                {
                  id: "1",
                  procedureName2: "Biomarker Analysis of CEA",
                  sampleType: "Archival tumor tissue",
                  tester: "Site Tester",
                },
              ]}
              showQuickFilter
            />
          </Box>

          {openDeleteProtocol && (
            <DeleteProtocolDialog
              openDeleteProtocol={openDeleteProtocol}
              setOpenDeleteProtocol={setOpenDeleteProtocol}
              deleteDoc={deleteDoc}
              setDeleteDoc={setDeleteDoc}
              getAllProtocolFunc={getAllProtocolFunc}
            />
          )}
        </>
      )}
    </>
  );
};

export default AssessmentPlans;
